import { COLORS } from "../consts/redesign/commonRedesign";
import { ClientStatusType, PyrusStatusType, reverseStatusMapping, RoleType } from "../types/managerApiTypes";

export const roleColorMap: Record<RoleType, string> = {
  "Клиент": COLORS.success,
  "Агент": COLORS.brand_blue,
  "Клиент агента": COLORS.brand_blue
};

export function getColorByRole(role: RoleType): string {
  return roleColorMap[role];
}

export const pyrusStatusColorMap: Record<PyrusStatusType, string> = {
  "Синхронизирован": COLORS.success,
  "Не синхронизирован": COLORS.warning,
};

export function getPyrusStatusText(synchronizePyrus: boolean | undefined | null): PyrusStatusType {
  if (synchronizePyrus === true) {
    return "Синхронизирован";
  } else {
    return "Не синхронизирован";
  }
}
export function getColorByPyrusStatus(pyrusStatus: PyrusStatusType): string {
  return pyrusStatusColorMap[pyrusStatus];
}

export const clientStatusDetails: Record<ClientStatusType, { fontColor: string; bgColor: string; label: string }> = {
  New: {
    fontColor: "4794EF",
    bgColor: "E2EEFC",
    label: "Новый"
  },
  Verified: {
    fontColor: "51B56B",
    bgColor: "E3F3E7",
    label: "Верифицирован"
  },
  LimitExceeded: {
    fontColor: "DC5103",
    bgColor: "F9E3D7",
    label: "Лимит превышен"
  },
  UnConfirmed: {
    fontColor: "7990A5",
    bgColor: "E4E8ED",
    label: "Аккаунт не подтверждён"
  },
  NotCompleteRegistration: {
    fontColor: "FFA800",
    bgColor: "FFF1D6",
    label: "Регистрация не завершена"
  }
};

export function getStatusDetails(status: ClientStatusType): {
  fontColor: string;
  bgColor: string;
  label: string
} {
  const statusKey = reverseStatusMapping[status];

  return clientStatusDetails[statusKey] || { fontColor: "#000000", bgColor: "#ffffff", label: "" };
}